import React from 'react';
import classes from './Spinner.module.css';

const spinner = (props) => {
  let styles = props.size ? [classes.Spinner, classes[props.size]].join(' ') : classes.Spinner;
  return <svg className={styles} style={props.customSpinnerStyle}><use xlinkHref='#icon-loader' />Loading...</svg>;
};

export default spinner;



// WEBPACK FOOTER //
// ./src/components/UI/Spinner/Spinner.js